import { css } from 'styled-components';
import optionBackground from 'assets/images/optionBackground.jpg';

export const sectionBackgroundStyles = css`
  width: 100%;
  height: 56px;
  background-image: url(${optionBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;
